import React, {useEffect, useState} from "react";
import AddButton from "../../components/AddButton";
import {withTranslation} from "react-i18next";
import DataTable from "../../components/DataTable";
import {createFilling} from "../../services/fillingService";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import Pagination from "../../components/Pagination";
import EditButton from "../../components/EditButton";
import DeleteButton from "../../components/DeleteButton";
import Select from "../../components/Select";
import swal from "sweetalert";
import {deleteFilling} from "../../services/fillingService";
import Loading from "../../components/loading";
import SearchInput from "../../components/search/SearchInput";
import {Context} from "../../context/SearchContext";
import {useContext} from "react";
import SettingButton from "../../components/SettingButton";
import {toast} from "react-toastify";
import TempDataTable from "../../components/TemDataTable";
import CopyButton from "../../components/CopyButton";
import {t} from "i18next";
import {action, getItem} from "../../services/service";

const headerTable = [{
    name: "id", sort: false
}, {
    name: "name", sort: true
}, {
    name: "clearance", sort: true
}, {
    name: "outer", sort: false
}, {
    name: "inner", sort: false
}, <span className="sr-only">Edit</span>,];

const bodyTable = ["id", "name", "clearance", "outer", "inner", "actions"];

const Filling = ({t}) => {
    const navigate = useNavigate();
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [itemOffset, setItemOffset] = useState(0);
    const [forcePage, setForcePage] = useState(0);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);
    const [data, setData] = useState({
        data: [],
        recordsTotal: 0,
        pageCount: 1,
    });
    const [isLoading, setIsLoading] = useState(true);
    const {token} = useSelector((state) => state.user);
    const ctx = useContext(Context);

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset =
            (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const deleteHandler = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            setIsLoading(true);
            const response = await deleteFilling(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/filling/group/${id}`,
                token
            );
            if (response.success) {
                setIsLoading(false);
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                setIsLoading(false);
                navigate("/error", {
                    state: {
                        status: response.status,
                        message: response.message ? response.message : null,
                    },
                });
            }
        } else {
            return;
        }
    };

    const onclickSetting = (item) => {
        if (item?.id > 0) {
            navigate(`/filling/specification/${item.id}`, {
                state: {
                    id: item.id,
                    name: item.name,
                }
            });
        }
    };

    const copyHandler = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            const response = await action(
              `${process.env.REACT_APP_HOST_BASE_URL}/v1/filling/group/copy/${id}`,
              'POST',
              token
            );
            if (response.success) {
                fetchData();
                toast.success(t("action.delete_success"), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success",
                });
            } else {
                navigate("/error", {
                    state: {
                        status: response.status,
                        message: response.message ? response.message : null,
                    },
                });
            }
        } else {
            return;
        }
    };
    const fetchData = async () => {
        const response = await createFilling(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/filling/group/table`,
            token,
            {
                draw: 1,
                start: itemOffset,
                length: itemsPerPage,
                recordsTotal: 0,
                columns: [],
                order: [{column: sortColumn, dir: sortDir}],
                search: {value: ctx.state, regex: true},
                filter: {},
            }
        );
        if (response.success) {
            setIsLoading(false);
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: index + 1,
                    name: item.name,
                    clearance: item.clearance,
                    outer: (
                        <fieldset>
                            <legend className="sr-only">Notifications</legend>
                            <div className="relative flex items-start">
                                <div className="flex items-center h-5">
                                    <input
                                        id="comments"
                                        aria-describedby="comments-description"
                                        name="comments"
                                        type="checkbox"
                                        className="w-4 h-4 text-gray-500 border-gray-600 rounded focus:ring-gray-300"
                                        checked={item.outer}
                                        readOnly
                                    />
                                </div>
                            </div>
                        </fieldset>
                    ),
                    inner: (
                        <fieldset>
                            <legend className="sr-only">Notifications</legend>
                            <div className="relative flex items-start">
                                <div className="flex items-center h-5">
                                    <input
                                        id="comments"
                                        aria-describedby="comments-description"
                                        name="comments"
                                        type="checkbox"
                                        className="w-4 h-4 text-gray-500 border-gray-600 rounded focus:ring-gray-300"
                                        checked={item.inner}
                                        readOnly
                                    />
                                </div>
                            </div>
                        </fieldset>
                    ),
                    actions: (
                        <>
                            <SettingButton onclick={(e) => onclickSetting(item)}/>
                            <CopyButton onclick={() => copyHandler(item.id)}/>
                            <EditButton
                                onclick={() => navigate(`/filling/update/${item.id}`)}
                            />
                            <DeleteButton onclick={() => deleteHandler(item.id)}/>
                        </>
                    ),
                };
            });
            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(
                    response.data.recordsFiltered / parseInt(itemsPerPage)
                ),
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchData();
        }
    }, [clear]);

    useEffect(() => {
        fetchData();
    }, [itemOffset, itemsPerPage, ctx.state]);

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    }

    return (
        <>
            {isLoading && <Loading/>}
            <div className="px-4 py-4 sm:px-6 lg:px-8">
                <div className="mb-3 sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-xl font-semibold text-gray-900">{t('FILLING')}</h1>
                    </div>
                    <AddButton title={t('action.add')} url={"add"}/>
                </div>
                <div>
                    <div className="flex justify-between items-center">
                        <Select
                            setItemsPerPage={setItemsPerPage}
                            itemsPerPage={itemsPerPage}
                        />
                        <SearchInput/>
                    </div>
                    <TempDataTable
                        data={data.data}
                        headerTable={headerTable}
                        bodyContent={bodyTable}
                        sortFunction={sortFunction}
                    />
                    <Pagination
                        handlePageClick={handlePageClick}
                        pageCount={data.pageCount}
                        forcePage={forcePage}
                    />
                </div>
            </div>
        </>
    );
};

export default withTranslation()(Filling);
